var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgWelcomeMascot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 211.794,
    height: 224.654,
    viewBox: "0 0 211.794 224.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 93,
    cy: 93,
    r: 93,
    transform: "translate(104 344)",
    fill: "#e2edf6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_welcome_mascot",
    transform: "translate(-94 -334)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 103,
    cy: 103,
    r: 103,
    transform: "translate(94 334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 93,
    cy: 93,
    r: 93,
    transform: "translate(104 344)",
    fill: "#e2edf6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(134.498 360.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21693",
    "data-name": "Path 21693",
    d: "M70.915,15.367a3.813,3.813,0,0,1-.493-1.88,4.063,4.063,0,0,1,.118-.944l2.5-10.563L63.6,4.991,64.772,0,54.442,3.3a15.023,15.023,0,0,0-10.2,13.442A71.083,71.083,0,0,0,16.465,141.043c-3.044,2.409-26.872,13.073-32.4,20.219s-4.818,9.364-3.257,15.471,6.107,7.532,12.825,7.532S16.9,168.514,16.9,169.6a11.039,11.039,0,0,0,1.45,5.55,11.6,11.6,0,0,0,7.18,5.3,16.664,16.664,0,0,0,5.316.426c-.019.347-.079.7-.079,1.046a15.928,15.928,0,0,0,.515,4.115,11.171,11.171,0,0,0,14.178,8.184,16.551,16.551,0,0,0,4.805-2.241,16.5,16.5,0,0,0,2.968,4.205,11.6,11.6,0,0,0,8.186,3.567c4.79,0,8.848-3.056,11.263-7.889a16.5,16.5,0,0,0,4.636,2.135,11.172,11.172,0,0,0,14.174-8.186,15.912,15.912,0,0,0,.515-4.114c0-.392-.065-.8-.09-1.2a16.583,16.583,0,0,0,5.165-.437,11.609,11.609,0,0,0,7.181-5.3,11,11,0,0,0,1.474-5.554c0-2.695.108-11.273-4.938-18.154,11.238-1.147,45.434-20.855,59.775-34.666S177.1,94.736,175.684,89.141s-15.061-10.1-20.294-7c-5.454,1.132-14.138,10.892-21.707,21.327S122.7,116.391,122.7,116.391s8.2-11.468,9.6-30.592A71.088,71.088,0,0,0,70.915,15.367",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21694",
    "data-name": "Path 21694",
    d: "M141.932,105.664A64.966,64.966,0,1,1,76.966,40.7a64.965,64.965,0,0,1,64.966,64.966",
    transform: "translate(-15.772 -19.865)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21695",
    "data-name": "Path 21695",
    d: "M88.993,140.558A28.369,28.369,0,1,1,60.625,112.19a28.372,28.372,0,0,1,28.369,28.368",
    transform: "translate(-25.659 -54.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21696",
    "data-name": "Path 21696",
    d: "M83.318,149.678c0,10.382-.178,15.847-7.826,15.847-3.289,0-10.965-6.443-14.2-8.423-3.982-2.436-5.674-1.506-5.674-7.424,0-10.383,6.2-18.8,13.85-18.8s13.85,8.42,13.85,18.8",
    transform: "translate(-37.062 -63.88)",
    fill: "#8dd7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21697",
    "data-name": "Path 21697",
    d: "M83.028,157.718c0,5.726-3.419,10.371-7.639,10.371s-7.64-4.645-7.64-10.371,3.421-10.372,7.64-10.372,7.639,4.642,7.639,10.372",
    transform: "translate(-42.983 -71.919)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21698",
    "data-name": "Path 21698",
    d: "M72.851,149.321c0,1.809-1.081,3.278-2.414,3.278s-2.417-1.469-2.417-3.278,1.082-3.279,2.417-3.279,2.414,1.469,2.414,3.279",
    transform: "translate(-43.116 -71.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21699",
    "data-name": "Path 21699",
    d: "M78.211,162.674a1.471,1.471,0,1,1-1.47-1.472,1.47,1.47,0,0,1,1.47,1.472",
    transform: "translate(-46.654 -78.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21700",
    "data-name": "Path 21700",
    d: "M191.465,140.558A28.369,28.369,0,1,1,163.1,112.19a28.371,28.371,0,0,1,28.368,28.368",
    transform: "translate(-75.675 -54.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21701",
    "data-name": "Path 21701",
    d: "M195.791,149.678c0,4.766-5.322,4.953-7.558,8.393-2.455,3.779-7.193,8.5-11.33,8.5-7.649,0-8.812-6.508-8.812-16.891s6.2-18.8,13.851-18.8,13.85,8.42,13.85,18.8",
    transform: "translate(-91.959 -63.88)",
    fill: "#8dd7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21702",
    "data-name": "Path 21702",
    d: "M195.5,157.718c0,5.726-3.422,10.371-7.639,10.371s-7.642-4.645-7.642-10.371,3.421-10.372,7.642-10.372,7.639,4.642,7.639,10.372",
    transform: "translate(-97.88 -71.919)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21703",
    "data-name": "Path 21703",
    d: "M185.323,149.321c0,1.809-1.079,3.278-2.415,3.278s-2.417-1.469-2.417-3.278,1.083-3.279,2.417-3.279,2.415,1.469,2.415,3.279",
    transform: "translate(-98.013 -71.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21704",
    "data-name": "Path 21704",
    d: "M190.683,162.674a1.471,1.471,0,1,1-1.47-1.472,1.469,1.469,0,0,1,1.47,1.472",
    transform: "translate(-101.551 -78.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21705",
    "data-name": "Path 21705",
    d: "M65.936,292.5c-6.93,0-11.924-1.74-11.924-5.882s5.618-7.5,12.548-7.5,30.912,3.357,30.912,7.5-16.755,2.794-23.686,2.794",
    transform: "translate(-36.278 -136.239)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21706",
    "data-name": "Path 21706",
    d: "M79.141,314.39c-6,3.466-12.546,3.366-14.616-.221s-2.149-12.47,7.154-16.733,28.413-8.583,30.483-5-17.018,18.485-23.021,21.95",
    transform: "translate(-40.856 -142.088)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21707",
    "data-name": "Path 21707",
    d: "M106.98,323.921c-3.465,6-9.182,9.189-12.767,7.119s-3.687-8.615-.221-14.616,18.364-25.092,21.95-23.022-5.5,24.518-8.962,30.519",
    transform: "translate(-54.555 -143.133)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21708",
    "data-name": "Path 21708",
    d: "M139.7,324.245c0,6.931-3.358,12.548-7.5,12.548s-7.5-5.617-7.5-12.548,3.358-30.912,7.5-30.911,7.5,23.98,7.5,30.911",
    transform: "translate(-70.78 -143.176)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21709",
    "data-name": "Path 21709",
    d: "M160.453,315.987c3.466,6,3.366,12.545-.22,14.615s-9.3-1.115-12.768-7.117-12.549-28.45-8.962-30.519,18.484,17.017,21.95,23.02",
    transform: "translate(-77.116 -142.92)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21710",
    "data-name": "Path 21710",
    d: "M174.4,294.278c3.211,4.014,4.284,12.693,2.214,16.279s-8.614,3.685-14.616.22-25.093-18.363-23.02-21.949,24.516-6.155,30.519-2.689",
    transform: "translate(-77.675 -138.863)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21712",
    "data-name": "Path 21712",
    d: "M123.29,20.723a12.422,12.422,0,0,1,.341-2.851,9.1,9.1,0,0,0-6.018,8.809c0,5.065,3.735,9.175,8.341,9.175A8.123,8.123,0,0,0,132.744,32c-5.292-.47-9.455-5.333-9.455-11.274",
    transform: "translate(-67.321 -8.724)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21713",
    "data-name": "Path 21713",
    d: "M140.464,24.1a10.168,10.168,0,0,1,.283-2.356,7.518,7.518,0,0,0-4.976,7.282c0,4.19,3.087,7.586,6.9,7.586a6.72,6.72,0,0,0,5.615-3.19c-4.375-.388-7.817-4.411-7.817-9.321",
    transform: "translate(-76.184 -10.615)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21714",
    "data-name": "Path 21714",
    d: "M144.57,191.322A11.574,11.574,0,1,1,133,179.651a11.622,11.622,0,0,1,11.574,11.671",
    transform: "translate(-74.423 -87.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21715",
    "data-name": "Path 21715",
    d: "M117.934,208.437c1.01-.565,5.282-3.63,10.442-4.376s6.979-.963,9.7.969c3.728,4.052-1.527,11.6-7.667,17.458a23.9,23.9,0,0,1-32.973,0l-.419-.4c-6.112-5.78-6.688-10.26-6.792-11.509s.509-5.647,6.367-4.182,10.067,4.584,15.335,3.7S116.925,209,117.934,208.437Z",
    transform: "translate(-52.733 -99.528)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21716",
    "data-name": "Path 21716",
    d: "M139.5,239.374a23.906,23.906,0,0,1-25.168,0,14.755,14.755,0,0,1,25.168,0",
    transform: "translate(-65.719 -113.396)",
    fill: "#f6921e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1012",
    "data-name": "Rectangle 1012",
    width: 142.217,
    height: 199.761,
    transform: "translate(-9.915 -0.001)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_22050",
    "data-name": "Path 22050",
    d: "M236.37,168.249c6.93,0,11.354,2,12.548,7.5s-9.221,14.92-9.221,14.92-26.787,26.473-49.7,33.693c-25.808,8.132-51.086,9.9-51.085,7.7,0-2.551,31.413-14.906,58.643-28.106,16.894-8.19,27.608-34.991,38.815-35.7",
    transform: "translate(56.78 278.242)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22051",
    "data-name": "Path 22051",
    d: "M9.12,56.805c-5,0-8.19-1.759-9.051-6.585s6.651-13.1,6.651-13.1S26.042,13.866,42.57,7.525C61.186.382,79.419-1.168,79.418.763,79.419,3,54.556,12.407,37.2,26.751c-12.186,7.193-20,29.429-28.08,30.054",
    transform: "translate(132.771 482.159) rotate(16)",
    fill: "#00bcf1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgWelcomeMascot);
export default __webpack_public_path__ + "static/media/img_welcome_mascot.63c0154bad703849096221308fbe243d.svg";
export { ForwardRef as ReactComponent };